module.exports = __webpack_public_path__ + "img/resursbank.38c7b4c.png";